// Headline numbers shown on the homepage stats bar and the About page — the
// homepage is the reference. Change them here and both places stay in step
// (labels: i18n `home.stats.<key>`).
// Only publish figures backed by records: curricula in backend docs/, the
// 2026 cohort schedule (13 weeks, 26 live classes). Swap in graduate and
// enrollment counts once they are pulled from the production database.
export const siteStats = [
  { key: "programs", value: 19, suffix: "" },
  { key: "weeksPerCohort", value: 13, suffix: "" },
  { key: "liveClasses", value: 26, suffix: "" },
];
